import type { ComponentStyleConfig } from '@chakra-ui/react';

const DividerComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    borderColor: 'neutral100',
    opacity: 1,
  },
};

export default DividerComponentStyle;
